import React from 'react';
import { LaboratoryRequestItem } from '../../Interfaces/LaboratoryRequestItem.intefrace';
// @ts-ignore
import styles from './LaboratoryRequestCreateFormItemTab.module.scss';
import LaboratoryRequestCreateFormItemChildren from './LaboratoryRequestCreateFormItemChildren';

interface Props {
	item: LaboratoryRequestItem;
	onItemSelect: (item: LaboratoryRequestItem) => void;
}

const LaboratoryRequestCreateFormItemTab: React.FC<Props> = ({
	item,
	onItemSelect,
}) => {
	return (
		<div className={styles.wrapper}>
			<LaboratoryRequestCreateFormItemChildren
				items={item.children}
				onItemSelect={onItemSelect}
			/>
		</div>
	);
};

export default LaboratoryRequestCreateFormItemTab;
